import { keymap } from "prosemirror-keymap";
import { marks as basicMarks } from "prosemirror-schema-basic";
import { Extension } from "../../core/extension";
import { bindCommandToKey, toggleMark } from "../../commands/commands";
export class BoldExtension extends Extension {
    addMarks(marks) {
        const { strong } = basicMarks;
        return marks.append({ strong });
    }
    addCommands(schema) {
        return {
            toggleBold: toggleMark(schema.marks.strong),
        };
    }
    addPlugins(schema, plugins, { commands }) {
        return plugins.concat([
            keymap({
                "Mod-b": bindCommandToKey(commands.toggleBold),
            }),
        ]);
    }
}
